
<ul>
    <li><span>{{mensaje}}</span></li>
    <br><br>
    <li><button (click)="close()" mat-raised-button color="warn">Aceptar</button></li>
</ul>